import runAfterPageLoad from "./runAfterPageLoad";
import tinyMCE from "tinymce";

export default function productForm() {
  runAfterPageLoad(() => {
    if ($("#product_form").length > 0) {
      initializeNewSelect2ProductForm();
    }
  });

  $(document).ready(() => {
    initializeTinyMCE();
  });
}
function initializeTinyMCE() {
  const tinymceConfig = {
    selector: "#appointment_meeting_details",
    plugins:
      "lists link image charmap preview  searchreplace visualblocks code fullscreen insertdatetime media code wordcount table",
    toolbar:
      "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist outdent indent | forecolor backcolor table",
    relative_urls: false,
    color_map: [
      "E20074",
      "Magenta",
      "FFFFFF",
      "White",
      "000000",
      "Black",
      "262626",
      "Gray 38",
      "4B4B4B",
      "Gray 5",
      "6C6C6C",
      "Gray 3",
      "7C7C7C",
      "Gray 2",
      "A4A4A4",
      "Gray 1",
      "D0D0D0",
      "Gray 6",
      "E6E6E6",
      "Gray 230",
      "EDEDED",
      "Gray 4",
      "FFD329",
      "Screen Yellow 100%",
      "FFDE5D",
      "Screen Yellow light",
      "DBAD39",
      "Screen Yellow dark",
      "FF9A1E",
      "Screen Orange 100%",
      "FFB356",
      "Screen Orange light",
      "D48936",
      "Screen Orange dark",
      "53BAF2",
      "Screen Light Blue 100%",
      "7ECBF5",
      "Screen Light Blue light",
      "317CB3",
      "Screen Light Blue dark",
      "1063AD",
      "Screen Dark Blue 100%",
      "529AD6",
      "Screen Dark Blue light",
      "235482",
      "Screen Dark Blue dark",
      "1BADA2",
      "Screen Petrol 100%",
      "65C8C0",
      "Screen Petrol light",
      "218076",
      "Screen Petrol dark",
      "BFCB44",
      "Screen Green 100%",
      "CFD89B",
      "Screen Green light",
      "889130",
      "Screen Green dark",
      "FF55AB",
      "Magenta mid (unofficial)",
      "FFC6E2",
      "Magenta light (unofficial)",
    ],
  };
  // eslint-disable-next-line
  tinyMCE.init(tinymceConfig);
}

function initializeNewSelect2ProductForm() {
  const valuesProductForm = $("#product_form_streams_select").find(
    ".product_form_streams-filter__values:not(.select2-initialized)"
  );
  valuesProductForm.select2({
    multiple: true,
    placeholder:
      "Every product must have a stream selected, even if hidden from it.",
    theme: "bootstrap",
  });
  // select2 does weird shit in multiple selects:
  // https://stackoverflow.com/questions/49943362/select2-multi-select-blank-option-always-selected/54809736#54809736
  valuesProductForm.addClass("select2-initialized");
}
